import cn from 'classnames'
import { FC } from 'react'

import { useSafetyTranslation } from 'cng-common/features/translations'
import { Translation } from 'cng-common/features/translations/components/translation'
import { Textarea } from 'core-components/library/inputs'
import { Tooltip } from 'core-components/library/tooltip'

import { useFormField } from '../../hooks/useFormField'
import { ReadOnlyField } from '../readOnlyField'

import { IFormTextareaProps } from './models'

import styles from './FormTextarea.module.scss'

export const FormTextarea: FC<IFormTextareaProps> = ({
  field,
  formKey,
  label = '',
  defaultValue,
  className,
  isDisabled,
  isRequired,
  isReadOnly,
  isVisible = true,
  onChange,
  onBlur,
  onValidate,
  validationType,
  resizable,
  rows,
  margin,
  placeholder,
  autoFocus,
}) => {
  const { handleBlur, handleChange, value, validationMessage, isModified } = useFormField<string>({
    field,
    formKey,
    defaultValue,
    onChange,
    onValidate,
    isDisabled,
    isRequired,
    isReadOnly,
    isVisible,
    onBlur,
    validationType,
  })

  const t = useSafetyTranslation()
  const translatedPlaceholder = placeholder ? t(placeholder) : undefined

  if (isVisible) {
    if (isReadOnly) {
      return <ReadOnlyField label={label} value={value} />
    }

    return (
      <div className={styles.validationContainer}>
        <Tooltip disabled={!validationMessage} tipContent={() => <>{validationMessage}</>}>
          <Textarea
            disabled={isDisabled}
            autoFocus={autoFocus}
            classes={{
              root: cn(className, {
                [styles.required]: isRequired && Boolean(label),
                [styles.modified]: isModified,
                [styles.invalid]: validationMessage,
              }),
            }}
            value={value}
            onChange={handleChange}
            onBlur={handleBlur}
            label={label && <Translation text={label} span />}
            rows={rows}
            margin={margin}
            resizable={resizable}
            placeholder={translatedPlaceholder}
          />
        </Tooltip>
      </div>
    )
  }

  return null
}
